'use strict';

angular.module('shiftTraderApp')
  .service('Session', ['storage', '$location', '$rootScope', '$injector', 'uuid4', 'EventTrackingService', '$log', '$q',
    function Session(storage, $location, $rootScope, $injector, uuid4, EventTrackingService, $log, $q) {
    var membership_data = null;
    var me;
    var momentTz = 'America/New_York';

    this.me = me;
    this.meTimestamp = (new Date()).getTime();
    this.mePromises = [];
    this.meDispatched = false;

    this.currentOrg = null;
    this.currentOrgTimestamp = (new Date()).getTime();
    this.currentOrgPromises = [];
    this.currentOrgDispatched = false;

    function isCacheValid(cacheValue, validLength) {
      return ((new Date()).getTime() - cacheValue ) < validLength;
    }

    this.generateNewSessionId = function() {
      var id = uuid4.generate();
      storage.set('sa_randomSessionId', id);
      return id;
    };

    this.getSessionId = function() {
      return storage.get('sa_randomSessionId');
    };

    this.generateNewSessionIdIfNotSet = function() {
      var currId = storage.get('sa_randomSessionId');
      if (_.isNull(currId) || _.isUndefined(currId)) {
        return this.generateNewSessionId();
      } else {
        return currId;
      }
    };

    this.getAccessToken = function () {
      return storage.get('sa_accessToken');
    };
    this.setAccessToken = function (accessToken) {
      storage.set('sa_accessToken', accessToken);
    };

    this.clearTokenStorage = function() {
      storage.remove('sa_accessToken');
      storage.remove('sa_refreshToken');
    };

    this.getRefreshToken = function() {
      return storage.get('sa_refreshToken');
    };

    this.setRefreshToken = function(refreshToken) {
      if (_.isUndefined(refreshToken)) {
        storage.remove('sa_refreshToken');
      } else {
        storage.set('sa_refreshToken', refreshToken);
      }
    };

    this.getCurrentOrgId = function () {
      return storage.get('sa_currentOrgId');
    };

    this.getCurrentOrg = function() {
      var deferred = $q.defer();

      if (isCacheValid(that.currentOrgTimestamp, 60 * 1000) && !!that.currentOrg) {
        deferred.resolve(that.currentOrg);
      } else {
        that.currentOrgPromises.push(deferred);
        if (!that.currentOrgDispatched) {
          that.currentOrgDispatched = true;
          var Organizations = $injector.get('Organizations');
          Organizations.getCurrentOrg()
            .then(function(org) {
              that.setCurrentOrg(org);
              _.each(that.currentOrgPromises, function(promise) {
                promise.resolve(org);
              });
              that.currentOrgPromises = [];
              that.currentOrgDispatched = false;
            }, function(response) {
              console.error('Session.getCurrentOrg failed');
              _.each(that.currentOrgPromises, function(promise) {
                promise.reject(response);
              });
              that.currentOrgPromises = [];
              that.currentOrgDispatched = false;
            });
        }
      }

      return deferred.promise;
    };

    this.setCurrentOrgId = function (orgId) {
      storage.set('sa_currentOrgId', orgId);
    };

    this.setCurrentOrg = function(org) {
      that.currentOrg = org;
      that.setCurrentOrgId(that.currentOrg.id);
      that.currentOrgTimestamp = (new Date()).getTime();
    };

    this.getEmailForLogin = function() {
      return (_.isNull(storage.get('sa_storedEmail')) || _.isUndefined(storage.get('sa_storedEmail'))) ?
        undefined :
        storage.get('sa_storedEmail');
    };

    this.saveEmailForLogin = function(email) {
      storage.set('sa_storedEmail', email);
    };

    this.clearEmailForLogin = function() {
      storage.remove('sa_storedEmail');
    };

    this.setTimezone = function(tzName) {
      switch(tzName) {
        case 'Eastern Time (US & Canada)':
          momentTz = 'America/New_York';
          break;
        case 'Central Time (US & Canada)':
          momentTz = 'America/Chicago';
          break;
        case 'Mountain Time (US & Canada)':
          momentTz = 'America/Denver';
          break;
        case 'Pacific Time (US & Canada)':
          momentTz = 'America/Los_Angeles';
          break;
        default:
          momentTz = 'America/New_York';
          $log.debug('No organization timezone set. Assuming America/New_York');
      }
      //$log.debug('set momentTz to: ' + momentTz);
    };

    this.getTimezone = function() {
      return momentTz;
    };

    this.setMe = function (data) {
      me = data;
      this.me = data;

      if (this.me.id) {
        var builtEvent = {
          event: 'sa_user_authed_in',
          currentUser: {
            id: this.me.id,
            name: this.me.name,
            firstName: this.me.first_name,
            lastName: this.me.last_name,
            email: this.me.email,
          }
        }

        if (this.me.phone_numbers && this.me.$primary_formatted_phone_number()) {
          builtEvent.currentUser.phoneNumber = this.me.$primary_formatted_phone_number();
        }

        if (this.me.memberships && this.me.memberships[0]) {
          builtEvent.currentUser.organizationId = this.me.memberships[0].organization_id;
          builtEvent.currentUser.organizationName = this.me.memberships[0].organization.name;
          builtEvent.currentUser.organizationTimezone = this.me.memberships[0].organization.organization_config.timezone;
          builtEvent.currentUser.role = this.me.memberships[0].role;
        }

        window.dataLayer.push(builtEvent)
      }

      membership_data = me.memberships;
      this.setCurrentOrgId(membership_data[0].organization.id);
      this.setStartOfWeekDay(me.memberships[0].organization.organization_config.work_week_start);
      this.setWorkDayStartHour(me.memberships[0].organization.organization_config.work_day_start_hour);
      storage.set('sa_currentUserId', this.me.id);
      $rootScope.$broadcast('updatedSessionMe');
    };

    this.getMe = function() {
      var deferred = $q.defer();

      if (isCacheValid(that.meTimestamp, 60 * 1000) && !!that.me) {
        deferred.resolve(that.me);
      } else {
        that.mePromises.push(deferred);
        if (!that.meDispatched) {
          that.meDispatched = true;
          var Users = $injector.get('Users');
          Users.whoAmI()
            .then(function(me) {
              that.setMe(me);
              _.each(that.mePromises, function(promise) {
                promise.resolve(me);
              });
              that.mePromises = [];
              that.meDispatched = false;
            }, function(response) {
              console.error('Session.getMe failed');
              _.each(that.mePromises, function(promise) {
                promise.reject(response);
              });
              that.mePromises = [];
              that.meDispatched = false;
            });
        }
      }

      return deferred.promise;
    }

    this.getMembershipData = function () {
      return membership_data;
    };

    this.setMembershipData = function (membData) {
      membership_data = membData;
    };

    this.clearSession = function() {
      this.clearTokenStorage();
      storage.remove('sa_currentCalendarDate');
      storage.remove('sa_currentOrgId');
      storage.remove('sa_startOfWeekDay');
      storage.remove('sa_currentUserId');
      $rootScope.$broadcast('flushCaches', true);
      this.me = null;
      me = null;
      membership_data = null;
    };

    var that = this;
    this.logout = function () {
      var userId = that.getCurrentUserId()
      EventTrackingService.addEvent('logout_called', { old_uuid: that.getSessionId(), user_id: userId });
      that.clearSession();
      $rootScope.$broadcast('flushCaches', true);
      storage.remove('sa_workPeriodIndexEndpointVersion');
      storage.remove('sa_usersIndexEndpointVersion');
      storage.remove('sa_organizationsShowEndpointVersion');
      $rootScope.$broadcast('loginStateChanged', {state: false});
      window.dataLayer.push({ event: 'sa_user_logout', currentUser: { id: userId } })
      $rootScope.$broadcast('updatedSessionMe');

      $location.path('/login');
    };

    this.isLoggedIn = function () {
      // if null or undefined, return false
      return !(_.isNull(storage.get('sa_accessToken')) || _.isUndefined(storage.get('sa_accessToken')));
    };

    this.setStartOfWeekDay = function(val) {
      return storage.set('sa_startOfWeekDay', val);
    };

    this.getStartOfWeekDay = function() {
      var temp = storage.get('sa_startOfWeekDay');
      if (_.isNull(temp) || _.isUndefined(temp)) {
        return 1;
      } else {
        return temp;
      }
    };

    this.getWorkDayStartHour = function() {
      return storage.get('sa_workDayStartHour');
    };

    this.setWorkDayStartHour = function(val) {
      return storage.set('sa_workDayStartHour', val);
    };

    this.getCurrentUserId = function() {
      var val = storage.get('sa_currentUserId');

      if (_.isUndefined(val) || _.isNull(val)) {
        return false;
      } else {
        return val;
      }
    };

    this.isFeatureEnabled = function(feature) {
      var deferred = $q.defer();

      that.getCurrentOrg()
        .then(function(org) {
          if (_.include(org.enabled_features, feature)) {
            deferred.resolve(true);
          } else {
            deferred.resolve(false);
          }
        })
        .catch(function(response) {
          console.error('Session.isFeatureEnabled failed');
          deferred.reject(response);
        });

      return deferred.promise;
    };
  }]);
